import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';

/**
 * Oriente la caméra principale selon l'arcade sélectionnée
 * @param {string} side - 'maxi' ou 'mandi'
 */
export const setCameraOrientation = (side) => {
    const camera = threeEngine.getCamera('main');
    const controls = threeEngine.getControls();
    
    if (!camera) return;
    
    if (side === 'maxi') {
        camera.up.set(0, -1, 0);
    } else if (side === 'mandi') {
        camera.up.set(0, 1, 0);
    }
    
    threeEngine.targetCenter();
    
    if (controls && controls.position0) {
        controls.position0.copy(camera.position);
        controls.up0.copy(camera.up);
    }
    
    threeEngine.updateControls();
};

/**
 * Récupère la caméra principale
 * @returns {Camera|null}
 */
export const getMainCamera = () => {
    return threeEngine.getCamera('main');
};

/**
 * Récupère les contrôles de la caméra
 * @returns {Controls|null}
 */
export const getCameraControls = () => {
    return threeEngine.getControls();
};
